import { render } from "./SideFload.vue?vue&type=template&id=6eae3bbc&scoped=true"
const script = {}

import "./SideFload.vue?vue&type=style&index=0&id=6eae3bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eae3bbc"]])

export default __exports__